import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & + * {
    margin-top: 4px;
  }
`;
